import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AdviceNoteDto } from '../models/dto/advice-note-dto.model';

@Injectable()
export class AdviceNotesService {
  constructor(private readonly httpClient: HttpClient) {}

  public getAdviceNotes(caseId: string): Observable<Array<AdviceNoteDto>> {
    const params = new HttpParams().set('caseNumber', caseId);

    return this.httpClient
      .get('/AdviceCaseManagement/GetAdviceNotes', { params })
      .pipe(map((data: Array<any>) => data.map((note) => new AdviceNoteDto().deserialize(note))));
  }

  public addAdviceNote(caseId: string, adviceNote: string): Observable<any> {
    const params = new HttpParams().set('caseNumber', caseId);

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.httpClient.put('/AdviceCaseManagement/AddAdviceNote', JSON.stringify(adviceNote), { headers, params });
  }
}
